<ion-header
  *ngIf="
    dataServ.menuSection && !isConcierge && didInit && !selectedMenuCategory
  "
>
  <ion-toolbar mode="ios">
    <ion-back-button
      color="dark"
      slot="start"
      defaultHref="/home"
      text=""
      icon="chevron-back"
    ></ion-back-button>

    <ion-title class="ion-no-padding">
      <ion-text color="primary" class="ion-text-center">
        <h1>
          <b
            [innerHtml]="
              (multiSection
                ? dataServ.sectionsTitle
                : dataServ.menuSection.title
              )
                | caption
                | translate
            "
          ></b>
        </h1>
      </ion-text>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-header *ngIf="selectedMenuCategory">
  <ion-toolbar mode="ios">
    <ion-buttons slot="start" class="back-button">
      <ion-button (click)="backToCategoryList()">
        <ion-icon
          slot="start"
          color="dark"
          name="chevron-back"
          size="large"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <!-- <ion-back-button color="dark" slot="start" defaultHref="" (click)="backToCategoryList()" text=""
      icon="chevron-back"></ion-back-button> -->

    <ion-title class="ion-no-padding">
      <ion-text color="primary" class="ion-text-center">
        <h1>
          <b
            [innerHtml]="
              (multiSection
                ? dataServ.sectionsTitle
                : dataServ.menuSection.title
              )
                | caption
                | translate
            "
          ></b>
        </h1>
      </ion-text>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content
  *ngIf="didInit && !dataServ.menuSection?.is_grouped_by_menu_category"
>
  <ng-container *ngIf="!multiSection; else multSec">
    <ion-grid *ngIf="dataServ.menuSection">
      <ion-row *ngIf="dataServ.menuSection.menu_categories">
        <ng-container *ngFor="let cat of dataServ.menuSection.menu_categories">
          <ng-container *ngIf="cat.menu_items ">
            <ion-col size="12" *ngFor="let item of cat.menu_items">
              <ng-container *ngIf="canUserSee(item)">
                <ng-container
                  *ngIf="
                    !reservationMode ||
                    (item.booking_system !== 'only timetable' &&
                      item.menu_item_books &&
                      item.menu_item_books.length > 0)
                  "
                >
                  <!-- <ion-card
                    (click)="detail(item)"
                    [class]="item.tags | tagClasses"
                  >
                    <ion-img
                      [src]="item.image_url"
                      *ngIf="item.image_url"
                    ></ion-img>

                    <div class="bottom">
                      <ion-text color="white">
                        <h2>
                          <b [innerHtml]="item.name | caption | translate"></b>
                        </h2>
                      </ion-text>
                    </div>
                  </ion-card> -->
                  <app-menu-section-item
                    [item]="item"
                    (itemClick)="detail($event)"
                  ></app-menu-section-item>
                </ng-container>
              </ng-container>
            </ion-col>
          </ng-container>
        </ng-container>
      </ion-row>
    </ion-grid>
  </ng-container>

  <ng-template #multSec>
    <ion-grid *ngIf="dataServ.menuSections">
      <ion-row
        *ngIf="
          (dataServ.menuSections | isComing) &&
            (dataServ.menuSections | isComing).length > 0;
          else noResult
        "
      >
        <ng-container *ngFor="let item of dataServ.menuSections | isComing">
          <ion-col size="12">
            <ion-card (click)="detail(item)" [class]="item.tags | tagClasses">
              <ion-img [src]="item.image_url" *ngIf="item.image_url"></ion-img>

              <div class="bottom">
                <ion-text color="white">
                  <h2><b [innerHtml]="item.name | caption | translate"></b></h2>
                </ion-text>
              </div>
            </ion-card>
          </ion-col>
        </ng-container>
      </ion-row>

      <ng-template #noResult>
        <ion-row>
          <ion-col size="12" class="no-result">
            <ion-icon color="dark" name="search-outline"></ion-icon>

            <ion-text color="dark">
              <h1>{{ "There is no open places" | translate }}</h1>
            </ion-text>
          </ion-col>
        </ion-row>
      </ng-template>
    </ion-grid>
  </ng-template>
</ion-content>

<ion-content
  *ngIf="didInit && dataServ.menuSection?.is_grouped_by_menu_category"
>
  <ng-container *ngIf="!multiSection && !selectedMenuCategory; else multSec">
    <ion-grid *ngIf="dataServ.menuSection" class="pt-15">
      <ion-row *ngIf="dataServ.menuSection.menu_categories">
        <ion-col class="ion-no-padding" size="12">
          <ion-label class="title-label" color="medium">
            <h1>
              <b>{{ "Categories" | translate }}</b>
            </h1>
          </ion-label>
        </ion-col>
        <ion-col
          size="12"
          *ngFor="let category of dataServ.menuSection.menu_categories"
        >
          <ion-card (click)="selectThisCategory(category)">
            <ion-img
              [src]="category.images[0]?.url"
              *ngIf="category.images[0]?.url"
            ></ion-img>
            <div class="bottom">
              <ion-text color="white">
                <h2>
                  <b [innerHtml]="category.title | caption | translate"></b>
                </h2>
              </ion-text>
            </div>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-container>

  <ng-container *ngIf="!multiSection && selectedMenuCategory">
    <ng-container *ngIf="selectedMenuCategory.menu_items">
      <ion-grid>
        <ion-row>
          <ion-col class="ion-no-padding" size="12">
            <ion-label class="title-label" color="medium">
              <h1>
                <b>{{ selectedMenuCategory.title | caption }}</b>
              </h1>
            </ion-label>
          </ion-col>
          <ion-col
            size="12"
            *ngFor="let item of selectedMenuCategory.menu_items"
          >
            <ng-container *ngIf="item.active">
              <ng-container
                *ngIf="
                  !reservationMode ||
                  (item.booking_system !== 'only timetable' &&
                    item.menu_item_books &&
                    item.menu_item_books.length > 0)
                "
              >
                <ion-card
                  (click)="detail(item)"
                  [class]="item.tags | tagClasses"
                >
                  <ion-img
                    [src]="item.image_url"
                    *ngIf="item.image_url"
                  ></ion-img>

                  <div class="bottom">
                    <ion-text color="white">
                      <h2>
                        <b [innerHtml]="item.name | caption | translate"></b>
                      </h2>
                    </ion-text>
                  </div>
                </ion-card>
              </ng-container>
            </ng-container>
          </ion-col>
          <!-- <ion-item lines="none" class="ion-no-margin" color="transparent">
            <ion-button class="back-button" (click)="backToCategoryList()" expand="block" fill="clear" shape="round">
              <ion-icon slot="start" name="chevron-back"></ion-icon>
              <ion-text color="primary">
                <h5 class="ion-no-margin pt-1">
                  {{"Back to Categories" | translate}}
                </h5>
              </ion-text>
            </ion-button>
          </ion-item> -->
        </ion-row>
      </ion-grid>
    </ng-container>
  </ng-container>

  <ng-template #multSec>
    <ion-grid *ngIf="dataServ.menuSections && !selectedMenuCategory">
      <ion-row
        *ngIf="
          (dataServ.menuSections | isComing) &&
            (dataServ.menuSections | isComing).length > 0;
          else noResult
        "
      >
        <ng-container *ngFor="let item of dataServ.menuSections | isComing">
          <ion-col size="12">
            <ion-card (click)="detail(item)" [class]="item.tags | tagClasses">
              <ion-img [src]="item.image_url" *ngIf="item.image_url"></ion-img>

              <div class="bottom">
                <ion-text color="white">
                  <h2><b [innerHtml]="item.name | caption | translate"></b></h2>
                </ion-text>
              </div>
            </ion-card>
          </ion-col>
        </ng-container>
      </ion-row>

      <ng-template #noResult>
        <ion-row *ngIf="!selectedMenuCategory">
          <ion-col size="12" class="no-result">
            <ion-icon color="dark" name="search-outline"></ion-icon>

            <ion-text color="dark">
              <h1>{{ "There is no open places" | translate }}</h1>
            </ion-text>
          </ion-col>
        </ion-row>
      </ng-template>
    </ion-grid>
  </ng-template>
</ion-content>

<ng-container *ngIf="!isRooms && !multiSection && isHaveAvailableOnDemand && isTypeGuestService">
  <ion-button class="book-now-button" (click)="goToReservationPage()" expand="block">
    {{ "Book Now" | translate | uppercase }}
  </ion-button>
</ng-container>
